import type { GridInitialState } from '@mui/x-data-grid';

export const buildAscendingSorting = (
  field: string,
): NonNullable<GridInitialState['sorting']> => ({
  sortModel: [{ field, sort: 'asc' }],
});
